import React from 'react'
import DocumentTitle from 'react-document-title'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import Table from '_/shared/components/table'
import Filter from '_/shared/components/filter'

/**
 * Events
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class Events extends React.Component {
  static contextTypes = {
    router: React.PropTypes.func
  }

  static propTypes = {
    events: React.PropTypes.object.isRequired
  }

  static fetchData (store, { query }) {
    return {
      events: store.get('/events', {
        ...query,
        limit: 15
      })
    }
  }

  render() {
    const query = this.context.router.getCurrentQuery()

    return (
      <DocumentTitle title="Events">
        <div>
          <Filter
            {...query}
            route="events" />
          <Table
            {...query}
            route="events"
            limit={15}
            list={this.props.events}
            columns={[{
              name: 'icon',
              width: 40,
              format: 'icon'
            }, {
              name: 'type',
              label: 'Event',
              sortable: true
            }, {
              name: 'formattedMessage',
              label: 'Details',
              format: 'eval'
            }, {
              name: ['user', 'name'],
              label: 'User'
            }, {
              name: 'createdAt',
              label: 'Date',
              format: 'date',
              sortable: true
            }]} />
        </div>
      </DocumentTitle>
    )
  }
}

export default Events



// WEBPACK FOOTER //
// ./modules/shared/pages/events.js